module.exports = __webpack_public_path__ + "static/img/logo.a663e26f.jpg";